module.exports = __webpack_public_path__ + "images/motorbike.aa0dce95e8ea298bc4c57fccdbd058fa.svg";